import styles from "./complaintmobilecard.module.css";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowUp } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { forwardRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import dayjs from "dayjs";

const OpenedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open</button>));

const ResolvedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved</button>));

const CancelledToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled</button>));

const OpenedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const ResolvedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const CancelledToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));


const ComplaintMobileCard = ({ item, changeCStatus }) => {
    const { isAuthenticated, user } = useAuth0();

    return (<Link className={`${styles.MaintenanceReqCard}`} to={'/request/complaints/details/' + item?.id}>
        <div className={`${styles.CardImgSec} Secondary`}>
            <img src={item?.image} class={`${styles.IMG}`} alt="" />
        </div>
        <div className={`${styles.MainReCardCon}`}>
            <div>
                <p className={`${styles.Title}`}>{item.title}</p>
                <div className={`${styles.MainReCardIdStatus}`}>
                    <p className={styles.MainReID}>{item?.tenant_name} <span>{item.apt_name}</span></p>
                    {item.is_archived === 0 && <div className={`${styles.MainReqConDropBU}`}>
                        {!(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                            {item.current_status === 0 && <Dropdown.Toggle as={OpenedToggleReadOnly} />}
                            {item.current_status === 2 && <Dropdown.Toggle as={ResolvedToggleReadOnly} />}
                            {item.current_status === 3 && <Dropdown.Toggle as={CancelledToggleReadOnly} />}
                        </Dropdown>}
                        {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                            {item.current_status === 0 && <Dropdown.Toggle as={OpenedToggle} />}
                            {item.current_status === 2 && <Dropdown.Toggle as={ResolvedToggle} />}
                            {item.current_status === 3 && <Dropdown.Toggle as={CancelledToggle} />}
                            <Dropdown.Menu className="DropDownMenuBoxCus">
                                <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(item, 0)}>Open</Dropdown.Item>
                                <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(item, 2)}>Resolved</Dropdown.Item>
                                <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(item, 3)}>Cancelled</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>}
                    </div>}
                </div>
                <div className={`${styles.MainReCardIdStatusTwo}`}>
                    <p className={`${styles.MainReDate}`}>Submitted {dayjs(item?.created_at).fromNow()}</p>
                    {item?.priority === 1 && <p className={`${styles.ReffStatus} ${styles.Low}`}>
                        <ArrowUp />
                        <span>Low</span>
                    </p>}
                    {item?.priority === 2 && <p className={`${styles.ReffStatus} ${styles.Medium}`}>
                        <ArrowUp />
                        <span>Medium</span>
                    </p>}
                    {item?.priority === 3 && <p className={`${styles.ReffStatus} ${styles.High}`}>
                        <ArrowUp />
                        <span>High</span>
                    </p>}
                </div>
            </div>
        </div>
    </Link>);
};

export default ComplaintMobileCard;